import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hm_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => localStorage.removeItem("hm_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hm_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const changePassword = async (current_password, new_password) => {
    const { data } = await api.post("/auth/change-password", { current_password, new_password });
    // Backend rotates the session; keep THIS device signed in with the fresh token.
    if (data?.token) localStorage.setItem("hm_token", data.token);
    setAdmin((prev) => (prev ? { ...prev, must_change_password: false } : prev));
  };

  const signOutEverywhere = async () => {
    try {
      await api.post("/auth/sign-out-everywhere");
    } finally {
      localStorage.removeItem("hm_token");
      setAdmin(null);
    }
  };

  const logout = () => {
    localStorage.removeItem("hm_token");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, changePassword, signOutEverywhere }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

const ROLE_PERMS = {
  owner: ["*"],
  content_admin: ["content", "settings"],
  scheduler_admin: ["scheduler", "scheduler_view"],
  support_admin: ["scheduler_view", "content"],
};

export const hasPerm = (admin, perm) => {
  const p = ROLE_PERMS[admin?.admin_role || "owner"] || [];
  return p.includes("*") || p.includes(perm);
};
